export const GET_ADD_NEW_CALENDAR = "GET_ADD_NEW_CALENDAR";
export const LISTING_CALENDAR = "LISTING_CALENDAR";
export const LISTING_LOADING_DATA = "LISTING_LOADING_DATA";
